componentRegistryInstance.register('image', 'read', 'hrd.components.form.ImageComponent');

hrd.components.form.ImageComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.ImageComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		let isStatic = field.data('static') == true;
		let type = this.getFieldType();
		if (isStatic) {
			klass = `${type}-field static-image ignore-for-fhs`;
			field.parent().addClass('static-image-container');
			field.hide();
		} else {
			klass = `${type}-field thumbnail ignore-for-fhs`;
			field.parent().addClass('thumbnail-container');
		}
		this._super(field, id, klass);
	},
	getReadOnlyField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},
	setReadOnlyField: function(field, value, object, options) {
		let name = this.getFieldName();
		var $parent = field.parent();
		if (field.data('parent-width')) {
			$parent.width(field.data('parent-width'));
		}
		if (field.data('parent-height')) {
			$parent.height(field.data('parent-height'));
		}
		var isStatic = field.data('static') == true;
		if (isStatic) {
			if (field.data('src')) {
				field.attr('src', field.data('src'));
				field.show();
			}
			if (field.data('srcFn')) {
				let srcFn = $.functionCase(name + '-src');
				if (typeof this.settings.reference[srcFn] === 'function') {
					let src = this.settings.reference[srcFn].call(this.settings.reference, object, this.getFormInstance());
					field.attr('src', src);
					field.show();
				} else {
					console.log(`function "${srcFn}" not yet available in proper object reference "${this.settings.reference._FULL_}"`);
				}
			}
			// nothing else to do by now. but if static is not editable nor hideable
		} else if (value && value.uid) {
			let th;
			if (field.data('th') != undefined) {
				th = field.data('th');
			} else {
				var keepRatio = field.data('keep-ratio') == undefined || field.data('keep-ratio') ? 'F' : '0';
				let hasLabelOnTop = $parent.hasClass('label-on-top');
				let deltaW = 20;
				let deltaH = 20 + (hasLabelOnTop ? $parent.find('label').outerHeight(true) : 0);

				// tolgo 20 px dalla width/height del container, in modo da starci sempre dentro...
				let ew = field.data('exact-width');
				var pw = (($parent.width() == null) || (($parent.width() - deltaW) <= 0)) ? 4095 : $parent.width() - deltaW;
				var usableWidth = (ew != undefined) ? ew : Math.min(pw, (field.data('width') == undefined) ? 4095 : parseInt(field.data('width')));
				var width = this.utils().leftPad(usableWidth.toString(16), 3, '0');

				let eh = field.data('exact-height');
				var ph = (($parent.height() == null) || (($parent.height() - deltaH) <= 0)) ? 4095 : $parent.height() - deltaH;
				var usableHeight = (eh != undefined) ? eh : Math.min(ph, (field.data('height') == undefined) ? 4095 : parseInt(field.data('height')));
				var height = this.utils().leftPad(usableHeight.toString(16), 3, '0');
				th = keepRatio + width + height;
			}

			field.attr('src', `${hrd.globals.contextRoot}/download.do?th=${th}&uid=${value.uid}`);

			if (field.data('hide-when-empty')) {
				this.showField(field);
			}
			// remove eventually added inline w and h
			field.css({
				width: '',
				height: ''
			});

			// use max height/max width in place of h e w
			if (field.data('width') != undefined) {
				field.css({
					maxWidth: field.data('width') + 'px'
				});
			}

			if (field.data('height') != undefined) {
				field.css({
					maxHeight: field.data('height') + 'px'
				});
			}
		} else {
			let initialWhenEmpty = field.data('use-initial-when-empty');
			if (initialWhenEmpty != undefined) {
				var useInitialWhenEmptyFn = $.functionCase(field.data('name') + '-use-initial-options');
				if (typeof this.settings.reference[useInitialWhenEmptyFn] === 'function') {
					var opts = this.settings.reference[useInitialWhenEmptyFn].call(this.settings.reference, object, this.getFormInstance());
					opts = $.extend({}, {
						bgColor: '#ffffff',
						width: field.data('width'),
						height: field.data('height'),
					}, opts);
					if (opts.fgColor == undefined) {
						opts.fgColor = $.colorHelper().computeTextColor(opts.bgColor);
					}
					if (opts.initialFrom != undefined) {
						opts.initial = opts.initialFrom.trim().substring(0, 1).toUpperCase();
						var $circleIconContainer = $parent.find('.circled-icon-container');
						if (!$circleIconContainer.exists()) {
							var template = `
								<div class="circled-icon-container">
									<div class="circled-icon" style="width:${opts.width}px; height:${opts.height}px;background-color:${opts.bgColor};color:${opts.fgColor};">${opts.initial}</div>
								</div>
							`;
							$circleIconContainer = $(template);
							field.after($circleIconContainer);
							if (opts.fontSize) {
								$circleIconContainer.find('.circled-icon').css('font-size', opts.fontSize);
							}
						}
						field.hide();
					}
				} else {
					console.log(`function "${useInitialWhenEmptyFn}" not yet available in proper object reference "${this.settings.reference._FULL_}"`);
				}
			} else {
				field.attr('src', 'download.do');
				if (field.data('hide-when-empty') && !field.data('editable')) {
					this.hideField(field, true);
				} else {
					var dw = field.data('width'), dew = field.data('empty-width');
					var dh = field.data('height'), deh = field.data('empty-height');
					if (dw || dew) {
						field.width(dew ? dew : dw);
					}
					if (field.data('height')) {
						field.height(deh ? deh : dh);
					}
				}
			}
		}
		if (field.data('editable')) {
			var editableInfo = $.evaluate(field.data('editable'));
			var $ei = $parent.find('.editable-image');
			if (!$ei.exists()) {
				$ei = $('<span class="editable-image"><i class="fas fa-cloud-upload-alt"></i></span>').appendTo($parent).hide();
			}
			$ei.attr('title', xlate('common.form.image.edit.tooltip'));

			field.off('load.ic').on('load.ic', (_) => {
				this.observingImageVisibility(field).then(() => {
					var position;
					switch (editableInfo.position) {
						case 'rb':
							position = { my: "left+10 bottom+3", at: "right bottom", of: field };
							break;
						case 'lt':
							position = { my: "right-10 top", at: "left top", of: field };
							break;
						case 'lb':
							position = { my: "right-10 bottom+3", at: "left bottom", of: field };
							break;
						case 'rt':
						default:
							position = { my: "left+10 top", at: "right top", of: field };
							break;
					}
					$ei.show().position(position).off('.ei').on('click.ei', evt => {
						var uploadImageFn = $.functionCase(name + '-upload-image');
						if (typeof this.settings.reference[uploadImageFn] === 'function') {
							// need to get a fresh object, because button can be clicked in the future
							var formData = this.formInstanceToObject();
							this.settings.reference[uploadImageFn].call(this.settings.reference, formData, this.getFormInstance());
						} else {
							console.log(`function "${uploadImageFn}" not yet available in proper object reference "${this.settings.reference._FULL_}"`);
						}
					}).tooltip();
				});
			});
		}
	},
	resetReadOnlyField: function(field, options) {
		var isStatic = field.data('static') == true;
		field.text('');
		field.removeAttr('src');
		if (isStatic) {
			field.hide();
		}
	},
	observingImageVisibility: function(field) {
		let deferred = $.Deferred();
		let element = field.get(0);

		// resolve early if all IntersectionObserver and IntersectionObserverEntry features are NOT natively supported.
		if ('IntersectionObserver' in window &&
			'IntersectionObserverEntry' in window &&
			'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
			var intersectionObserver = new IntersectionObserver((entries) => {
				// If intersectionRatio is 0, the target is out of view and we do not need to do anything.
				if (entries[0].intersectionRatio <= 0) {
					deferred.reject();
				} else {
					intersectionObserver.unobserve(element);
					deferred.resolve();
				}
			});
			//start observing
			intersectionObserver.observe(element);
		} else {
			// se non supporta observing --> risolve subito
			deferred.resolve();
		}
		return deferred.promise();
	},

});